import {Botao, BotaoPesquisar, PaginaLogada, SelectFetch} from "../../componentes";
import {Card} from "react-bootstrap";
import CardHeader from "react-bootstrap/CardHeader";
import React, {useEffect, useState} from "react";
import {CirastServico} from "../../servicos";
import {exibirMensagemErro, formatarData, formatarDinheiroItl} from "../../util";

export default function RelatorioPagamentoCirast() {
  const [isCarregando, setIsCarregando] = useState(false)
  const [clinicas, setClinicas] = useState([])
  const [resultado, setResultado] = useState({})
  const [relatorioCmd, setRelatorioCmd] = useState({
    idClinica: -1,
    dtInicial: '',
    dtFinal: '',
    tpAtendimento: -1,
    cpf: ''
  })

  function consultaClinicas() {
    setIsCarregando(true)
    CirastServico.consultarClinica()
      .then(res => res.json())
      .then(dados => setClinicas(dados))
      .catch((e) => exibirMensagemErro('Erro ao buscar clinica'))
      .finally(() => setIsCarregando(false))
  }

  function entradaValida() {
    if (!relatorioCmd.dtFinal || !relatorioCmd.dtInicial) {
      return 'Selecione o intervalo de datas'

    }

    const dtInicial = new Date(relatorioCmd.dtInicial);
    const dtFinal = new Date(relatorioCmd.dtFinal);

    if (dtFinal < dtInicial) {
      return 'Data final menor que a inicial'
    }

    return false
  }

  function buscar(e) {
    e.preventDefault()

    const erro = entradaValida()
    if (erro) {
      exibirMensagemErro(erro)
      return
    }

    setIsCarregando(true)
    CirastServico.buscarRelatorio(relatorioCmd)
      .then(res => res.json())
      .then(dados => setResultado(dados))
      .catch((ex) => exibirMensagemErro('Erro ao gerar relatório'))
      .finally(() => setIsCarregando(false))
  }

  useEffect(() => {
    consultaClinicas()
  }, [])

  function relatorioExcel() {
    setIsCarregando(true)
    CirastServico.buscarRelatorioXls(relatorioCmd)
      .finally(() => setIsCarregando(false))
  }

  function relatorioPdf() {
    setIsCarregando(true)
    CirastServico.buscarRelatorioPdf(relatorioCmd)
      .finally(() => setIsCarregando(false))
  }

  return (
    <PaginaLogada titulo='Relatório Cirast' isCarregando={isCarregando}>
      <div className="row">
        <div className="col-lg-12">
          <Card>
            <CardHeader>Filtros</CardHeader>
            <div className="card-body">
              <div className='row'>

                <div className="col-lg-2">
                  <label>Clínica:</label>
                  <select
                    onChange={(e) => setRelatorioCmd({...relatorioCmd, idClinica: Number.parseInt(e.target.value)})}
                    className="form-control">
                    <option value={-1}>Todas</option>
                    {clinicas.map((v, k) => {
                      return (<option value={v.id} key={k}>{v.nome}</option>)
                    })}
                  </select>
                </div>

                <div className="col-lg-2">
                  <label>CPF Paciente:</label>
                  <input
                    type="text"
                    className="form-control"
                    value={relatorioCmd.cpf}
                    onChange={(e) => { setRelatorioCmd({...relatorioCmd, cpf: e.target.value})}}/>
                </div>

                <div className="col-lg-2">
                  <label>Tipo Atendimento:</label>
                  <SelectFetch
                    url={'/cirast/tipoAtendimento'}
                    setIsCarregando={setIsCarregando}
                    handleChange={(e) =>
                      console.log(e) & setRelatorioCmd({...relatorioCmd, tpAtendimento: Number.parseInt(e.value)})}
                    placeholder='Selecione o atendimento'/>
                </div>

                <div className="col-lg-2">
                  <label>Data inicial</label>
                  <input onChange={(e) => setRelatorioCmd({...relatorioCmd, dtInicial: e.target.value})}
                         type='date'
                         className='form-control'/>
                </div>

                <div className="col-lg-2">
                  <label>Data final</label>
                  <input onChange={(e) => setRelatorioCmd({...relatorioCmd, dtFinal: e.target.value})}
                         type='date' className='form-control'/>
                </div>

                <div className="col-lg-2 mt-2">
                  <BotaoPesquisar onClick={buscar} className='mt-4'/>
                </div>
              </div>
            </div>
          </Card>

          <hr/>

          <div className={'row'}>
            <div className={`col-lg-12 ${resultado?.valorTotal ? '' : 'd-none'}`}>
              <Card>
                <CardHeader>Resultado</CardHeader>

                <div className="card-body">
                  <table className="table table-bordered mb-5">
                    <thead>
                      <tr>
                        <th>Qtd Atendimentos</th>
                        <th>Valor Total</th>
                        <th>Exportar</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{resultado?.atendimentos?.length}</td>
                        <td>{formatarDinheiroItl(resultado.valorTotal)}</td>
                        <td>
                          <Botao icone="bi bi-file-pdf"
                            onClick={relatorioPdf}>
                            PDF
                          </Botao>
                          <Botao icone="bi bi-filetype-xls" cor="success"
                            onClick={relatorioExcel}>
                            Excel
                          </Botao>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {gerarTabelaResultado(resultado)}
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </PaginaLogada>
  )

  function gerarTabelaResultado(resultado) {
    return <table className='table table-hover table-bordered table-striped'>
      <thead>
      <tr>
        <th>Nº</th>
        <th>CPF atendido</th>
        <th>Nome</th>
        <th>Tipo Atendimento</th>
        <th>Clinica</th>
        <th>CNPJ clinica</th>
        <th>Data Atendimetno</th>
      </tr>
      </thead>
      <tbody>
      {resultado?.atendimentos?.map((v, k) => {
        return (<tr key={k}>
          <td>{k}</td>
          <td>{v?.cpfPaciente}</td>
          <td>{v?.nomePaciente}</td>
          <td>{v?.tipoAtendimento}</td>
          <td>{v?.nomeClinica}</td>
          <td>{v?.cnpjClinica}</td>
          <td>{formatarData(v?.dataAtendimento) + ' - ' + v?.dataAtendimento.substring(11)}</td>
        </tr>)
      })}
      </tbody>
    </table>;
  }
}